import { Flex, Text } from "@chakra-ui/react";
import { AiOutlineClose } from "react-icons/ai";
import IsDesktop from "../../utils/IsDesktop";

const ViewPitchDeck = ({ pitchDeck, onTogglePitchDeck }) => {
  const isDesktop = IsDesktop();
  return (
    <>
      <Flex width="95%" cursor="pointer" onClick={onTogglePitchDeck} justifyContent="flex-end" alignItems="center">
        <Flex mr={2}>
          <Text color="brand.primary">Close</Text>
          <AiOutlineClose size="20px" />
        </Flex>
      </Flex>
      {isDesktop ? (
        <>
          {pitchDeck ? (
            <iframe title="document viewer" src={`https://docs.google.com/viewer?url=${pitchDeck}&embedded=true`} width="95%" height="90%"></iframe>
          ) : (
            <Text>No Pitch Deck</Text>
          )}
        </>
      ) : (
        <>
          {/* <object data={pitchDeck} type="application/pdf" width="100%" height="90%" /> */}
          {pitchDeck ? (<object width="100%" height="90%" data={`https://drive.google.com/viewerng/viewer?embedded=true&url=${pitchDeck}`} type="application/pdf">
            {/* <embed width="100%" height="90%" src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${pitchDeck}`} type='application/pdf'/> */}
            <iframe title="document viewer" src={`https://docs.google.com/viewer?url=${pitchDeck}&embedded=true`} width="100%" height="90%"></iframe>
          </object>):(<Text>No Pitch Deck</Text>)}
        </>
      )}
    </>
  );
};
export default ViewPitchDeck;
